import React, { useState } from "react";
import { CheckCircle2Icon, Loader2Icon } from "lucide-react";
type Status = "idle" | "sending" | "sent" | "error";
export function ContactForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  const update = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm({
    ...form,
    [k]: e.target.value
  });
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.email.includes("@") || !form.message.trim()) {
      setStatus("error");
      return;
    }
    setStatus("sending");
    setTimeout(() => setStatus("sent"), 900);
  };
  const field = "w-full rounded-md border border-neutral-300 px-3 py-2.5 text-sm outline-none transition-colors duration-150 focus:border-brand";
  return;
}